import { IPROP_MAP, modifyProps } from '../../generators/modifyProps';

import { JDSProgressBarProps } from './generated';

export interface ProgressBarProps
  extends Omit<JDSProgressBarProps, 'valueLabel'> {
  /**
   * Value in %. The number should be in between 0 and 1. e.g. 0.55
   */
  value?: number;
  /**
   * determinate type shows the provided value, indeterminate type shows a constant
   * loading animation.
   * @deprecated
   * Use `kind`
   */
  type?: 'determinate' | 'indeterminate';
  /**
   * Main Label for the progress.
   */
  label?: string;
  /**
   * Support text for the label. You can pass % complete here to make best use
   * of valueLabel. e.g. `{progress * 100}%`
   *
   * Passing JSX Element is deprecated. Pass a string always
   */
  valueLabel?: string | JSX.Element;
  custom?: string;
  ariaLabel?: string;
  ariaDescribedby?: string;
}

export const PROP_MAP: IPROP_MAP<ProgressBarProps> = (props) => ({
  type: {
    properties: {
      kind: props.type
    }
  }
});

export const withLogic =
  (
    Component: React.ComponentType<ProgressBarProps>
  ): React.FC<ProgressBarProps> =>
  (userProps: ProgressBarProps) => {
    const props = modifyProps(userProps, PROP_MAP);
    const { value = 0, ...rest } = props;
    const min = 0;
    const max = value < 1 ? 1 : 100;
    const calculatedValue = value / (max - min);
    return (
      <Component
        {...{
          ...rest,
          value: calculatedValue,
          _invisible: 1 - calculatedValue,
          _ariaValuenow:
            props.kind === 'indeterminate' ? undefined : props.value,
          _ariaValuemin: props.kind === 'indeterminate' ? undefined : '0',
          _ariaValuemax: props.kind === 'indeterminate' ? undefined : '100',
          ariaBusy: props.kind === 'indeterminate' ? 'true' : props.ariaBusy
        }}
      />
    );
  };
